import styles from 'styled-components'

export const Banner = styles.div`
    text-align: center;   
    margin: 2em auto;
    
    `
